import script from "./AlertsChip.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertsChip.vue?vue&type=script&setup=true&lang=js"

import "./AlertsChip.vue?vue&type=style&index=0&id=19351050&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19351050"]])

export default __exports__